import PropTypes from 'prop-types';
export const scorePropTypes = {
  i18n: PropTypes.object,
  score: PropTypes.number,
  votes: PropTypes.number,
  onStarClick: PropTypes.func,
  hasVoted: PropTypes.bool
};